import {takeEvery, all, put, call} from 'redux-saga/effects';

// actionTypes
import * as actionTypes from '../redux/actionsTypes/Types';

// actions
import { loginAction} from '../redux/actions/LoginActions';

// services
import { loginUser } from '../api/services/LoginServices';
import { showErrorNotification } from '../customHooks';

// Worker saga
function* loadUser(action){
    try{
        const userData = yield call(loginUser, action.payload.loginDetails);
        yield localStorage.setItem('authUser', JSON.stringify({...userData,}));
        let payload ={
           user: {...userData}
        }
        yield put(loginAction(actionTypes.LOGIN_SUCCESS,payload));
        action.payload.navigate('/dashboard')
    }catch(error){
        yield put(loginAction( actionTypes.LOGIN_FAILED,error.response));
        showErrorNotification(error.response.data.message)
    }
}

// watcher saga
function* watchLogin() {
    yield takeEvery(actionTypes.LOGIN_START, loadUser);
}
export function* loginSaga(){
    yield all([
        watchLogin()
    ])
}

